export enum LineHeight {
  TextDisplay = '48px',
  TextH1 = '40px',
  TextH2 = '32px',
  TextH3 = '28px',
  TextH4 = '24px',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional: these are semantic typography tokens, so distinct text styles sharing a line height is expected rather than a copy-paste slip
  TextBodyLG = '24px',
  TextBodyMD = '20px',
  TextBodySM = '16px',
}
